import Plan from 'Classes/Plan';
import Client from 'Classes/Client';
import Agent from 'Classes/Agent';
import Household from 'Classes/Household';
import { PURGE } from 'redux-persist';
import {
  ADVISOR_HOVER_NAVIGATOR,
  ADVISOR_HOVER_SIDEBAR,
  ADVISOR_LEAVE_NAVIGATOR,
  ADVISOR_LEAVE_SIDEBAR,
  CLIENT_AGREEMENT,
  DECREASE_API_WAIT,
  DEPENDENTS_FLYOUT,
  EDIT_ACTION_ITEM_MODAL,
  END_SESSION,
  FINANCIAL_GOALS_FLYOUT,
  FORM_PART_A,
  FORM_PART_B,
  HOUSEHOLD_FLYOUT,
  CREATE_HOUSEHOLD_FLYOUT,
  HOUSEHOLD_INFO_FLYOUT,
  INCREASE_API_WAIT,
  ORDER_66,
  PRIVACY_POLICY,
  SET_AGENT,
  SET_CLIENT,
  SET_HOUSEHOLD_CHILDREN,
  SET_HOUSEHOLD_CLIENTS,
  SET_HOUSEHOLD_SERVICES,
  SET_PLAN,
  SET_USER,
} from './actions';

const initialState = {
  user: {},
  client: new Client(),
  household: new Household(),
  recentClients: [],
  agent: new Agent(),
  plan: new Plan(),
  apiWaitCount: 0,
  displayClientAgreement: null,
  displayFormPartA: false,
  displayFormPartB: false,
  displayPrivacyPolicy: false,
  activityModal: false,
  displayClientServicesFlyout: false,
  displayHouseholdInfoFlyout: false,
  displayCreateHouseholdFlyout: false,
  displayDependentsFlyout: false,
  displayFinancialGoalsFlyout: false,
  displayHouseholdFlyout: 0,
  tagModal: false,
  order66Complete: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SET_HOUSEHOLD_CLIENTS:
      return {
        ...state,
        household: Object.assign(new Household(), state.household, {
          clients: action.clients,
        }),
      };
    case SET_HOUSEHOLD_SERVICES:
      return {
        ...state,
        household: Object.assign(new Household(), state.household, {
          services: action.services,
        }),
      };
    case SET_AGENT:
      return { ...state, agent: Object.assign(new Agent(), action.agent) };
    case SET_HOUSEHOLD_CHILDREN:
      return {
        ...state,
        household: Object.assign(new Household(), state.household, {
          children: action.children,
        }),
      };
    case INCREASE_API_WAIT:
      return { ...state, apiWaitCount: state.apiWaitCount + action.n };
    case DECREASE_API_WAIT:
      return { ...state, apiWaitCount: state.apiWaitCount - action.n };
    case SET_PLAN:
      return { ...state, plan: Object.assign(new Plan(), action.plan) };
    case SET_USER:
      return {
        ...state,
        user: Object.assign(action.user, { apiKey: action.apiKey }),
      };
    case END_SESSION:
      return { ...initialState };
    case SET_CLIENT:
      return {
        ...state,
        client: { ...action.client },
        recentClients: ((client, prevRecents) => {
          const nextRecents = [];
          if (client.id > 0) {
            nextRecents.push(client);
          }
          prevRecents.forEach((recentClient) => {
            if (Number(recentClient.id) !== Number(client.id)) {
              nextRecents.push(recentClient);
            }
          });
          return nextRecents;
        })(action.client, state.recentClients),
      };
    case ADVISOR_HOVER_NAVIGATOR:
      return {
        ...state,
        activeNavigatorName: action.payload.name,
        activeNavigatorTop: action.payload.top,
      };
    case ADVISOR_LEAVE_NAVIGATOR:
      return { ...state };
    case ADVISOR_HOVER_SIDEBAR:
      return { ...state, sidebarIsActive: true };
    case ADVISOR_LEAVE_SIDEBAR:
      return { ...state, sidebarIsActive: false };
    case PURGE:
      return initialState;
    case CLIENT_AGREEMENT:
      return { ...state, displayClientAgreement: action.display };
    case FORM_PART_A:
      return { ...state, displayFormPartA: action.display };
    case FORM_PART_B:
      return { ...state, displayFormPartB: action.display };
    case PRIVACY_POLICY:
      return { ...state, displayPrivacyPolicy: action.display };
    case ORDER_66:
      return { ...state, order66Complete: action.complete };
    case EDIT_ACTION_ITEM_MODAL:
      return { ...state, editActionItemModal: action.display };
    case FINANCIAL_GOALS_FLYOUT:
      return { ...state, displayFinancialGoalsFlyout: action.display };
    case DEPENDENTS_FLYOUT:
      return { ...state, displayDependentsFlyout: action.display };
    case HOUSEHOLD_INFO_FLYOUT:
      return { ...state, displayHouseholdInfoFlyout: action.display };
    case HOUSEHOLD_FLYOUT:
      return { ...state, displayHouseholdFlyout: action.id };
    case CREATE_HOUSEHOLD_FLYOUT:
      return { ...state, displayCreateHouseholdFlyout: action.display };
    default:
      return state;
  }
}
